// extracted by mini-css-extract-plugin
var _1 = "ProfileEntityWidgetItemContent-moduleProfileEntityWidgetItemContent__Qa8pT";
var _2 = "ProfileEntityWidgetItemContent-moduledescription__GCwSP ListItemContent-moduledescription__jaeCE";
var _3 = "ProfileEntityWidgetItemContent-modulenotInteractive__QKHZW";
var _4 = "ProfileEntityWidgetItemContent-moduletext__NPRlc ListItemContent-moduletext__Rd9WF";
var _5 = "ProfileEntityWidgetItemContent-moduletextContainer__elv8_ ListItemContent-moduletextContainer__LZn5S";
export { _1 as "ProfileEntityWidgetItemContent", _2 as "description", _3 as "notInteractive", _4 as "text", _5 as "textContainer" }
